module.exports = __webpack_public_path__ + "media/images/emblems/Pery-La_Heutte-coat_of_arms-27e33913ecb73d0a2ec461cbf4efa7f2.svg";